import moment from 'moment-timezone';
/** Default open and close time the opening hour item created with */
export const defaultTime = {
    start: '08:00',
    end: '16:30',
};
/**
 * Gets date as it was a UTC date
 *
 * @param date Moment date object
 */
export function getDateAsUTC(date) {
    return moment.utc({
        year: date.year(),
        month: date.month(),
        date: date.date(),
    });
}
